import PendoCard from '../../../components/card/pendo-card.vue.js';
import PendoMetric from '../../../components/metric/pendo-metric.vue.js';
import PendoStatusOverlay from '../../status-overlay/pendo-status-overlay.vue.js';
import forIn from 'lodash/forIn.js';
import get from 'lodash/get.js';

var script = {
  name: 'TopStats',
  components: {
    PendoCard,
    PendoMetric,
    PendoStatusOverlay
  },
  props: {
    topStats: {
      type: Array,
      required: true
    },
    topStatsConfig: {
      type: Object,
      default: () => {}
    },
    guideAlertsAggStatus: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      statsData: {},
      notReviewed: [],
      triage: [],
      resolved: []
    };
  },
  computed: {
    notReviewedAlerts() {
      if (!this.isLoading) {
        return this.notReviewed.length;
      }
      return;
    },
    triageAlerts() {
      if (!this.isLoading) {
        return this.triage.length;
      }
      return;
    },
    resolvedAlerts() {
      if (!this.isLoading) {
        return this.resolved.length;
      }
      return;
    },
    hasLoadingError() {
      return this.guideAlertsAggStatus === 'rejected';
    },
    isLoading() {
      return this.guideAlertsAggStatus === 'loading';
    }
  },
  watch: {
    topStats: {
      deep: true,
      immediate: true,
      handler(data) {
        this.statsData = data;
        this.notReviewed = [];
        this.triage = [];
        this.resolved = [];
        forIn(this.statsData, alert => {
          switch (alert.alertStatus) {
            case 'NotReviewed':
              this.notReviewed.push(alert);
              break;
            case 'Triage':
              this.triage.push(alert);
              break;
            case 'Resolved':
              this.resolved.push(alert);
              break;
          }
        });
      }
    }
  },
  mounted() {
    const collapsed = get(this.topStatsConfig, 'value.collapsed', false);
    if (collapsed) {
      this.$refs.pendoCard.collapseCard();
    }
  },
  methods: {
    saveCollapseState(state) {
      const settings = {
        name: 'displayAlertTopStats',
        namespaced: true,
        value: state,
        forced: true
      };
      this.$emit('update-user-settings', settings);
    }
  }
};

export { script as default };
//# sourceMappingURL=guide-alerts-top-stats.vue2.js.map
